import React from 'react';
export const TextualSeparator = ({ data }) => {
    return (React.createElement("div", { className: "d-flex justify-content-center align-items-center" },
        React.createElement("hr", { className: 'd-block lined-block' }),
        React.createElement("div", { className: 'mx-2 my-0' }, data),
        React.createElement("hr", { className: 'd-block lined-block' })));
};
